import { createFileRoute } from "@tanstack/react-router";
import { createSocialHeadMeta } from "~/lib/social-head";
import { PRE_IPO_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/pre-ipo")({
  head: () => ({
    meta: createSocialHeadMeta(PRE_IPO_SOCIAL_METADATA),
  }),
  loader: createRwaMarketsRouteLoader("pre-ipo"),
});
